import driverReward from '../../views/driver-reward/driver-supplement-reward.vue';
import driverGrant from '../../views/driver-reward/driver-grant.vue';
var driverModel = [
    {
        name: 'driverSupAward',
        path: 'driver-reward',
        component: driverReward,
    },
    {
        name: 'driverGrant',
        path: 'driver-grant',
        component: driverGrant,
    },
];
export default driverModel;
